import Notification from '@service-victoria/component-library/components/Notification';
import RadioButton from '@service-victoria/component-library/components/RadioButton';
import Text from '@service-victoria/component-library/components/Text';
import { useField } from 'formik';
import React, { useEffect, useState } from 'react';
import { checkAvailability, VoucherTypes } from 'services/voucherService';

const voucherLabel: Record<VoucherTypes, string> = {
  metro: 'Melbourne Metro',
  regional: 'Regional Victoria'
};

export default function VoucherType() {
  const [isTechnicalError, setTechnicalError] = useState(false);
  const [{ value: voucherType }] = useField<VoucherTypes>('abn.voucherType');
  const [{ value: vouchersAvailable }, , { setValue }] = useField<boolean | undefined>(
    'abn.vouchersAvailable'
  );
  const knownVouchers = React.useRef<Record<VoucherTypes, boolean | undefined>>({
    metro: undefined,
    regional: undefined
  });

  const checkVoucherStatus = async () => {
    setTechnicalError(false);

    if (knownVouchers.current[voucherType] !== undefined) {
      // return from cache
      setValue(knownVouchers.current[voucherType]);
      return;
    }

    const res = await checkAvailability(voucherType);
    const isAvailable = res.status === 'SUCCESS';

    // Only store it as known if is not a technical error.
    if (res.status !== 'TECHNICAL_ERROR') {
      setValue(isAvailable);
      knownVouchers.current[voucherType] = isAvailable;
    } else {
      setValue(undefined);
      setTechnicalError(true);
    }
  };

  useEffect(() => {
    checkVoucherStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [voucherType]);

  const isVoucherError =
    vouchersAvailable === false && voucherType !== undefined && !isTechnicalError;
  return (
    <>
      <RadioButton
        id='abn.voucherType'
        name='abn.voucherType'
        groupLabel='This voucher will be used in'
        items={Object.keys(VoucherTypes).map(voucherType => ({
          value: voucherType,
          label: voucherLabel[voucherType]
        }))}
      />
      <Text.Body>
        City of Melbourne locations are not eligible for a voucher under this program.
      </Text.Body>
      {isVoucherError && (
        <Notification.Error.Field
          title='Quota Unavailable'
          aria-invalid={true}
          aria-labelledby='abn.voucherType'>
          Sorry, applications are now closed for {voucherLabel[voucherType]}
        </Notification.Error.Field>
      )}
      {isTechnicalError && (
        <Notification.Error.Field
          title='There was an error checking the quota'
          aria-invalid={true}
          aria-labelledby='abn.voucherType'>
          <span>
            <Text.Link
              href=''
              onClick={e => {
                e.preventDefault();
                checkVoucherStatus();
              }}
              value='Click here'
            />{' '}
            to try again
          </span>
        </Notification.Error.Field>
      )}
    </>
  );
}
